<template>
  <div class="ordinate-property-section" data-testid="ordinate-property-section"></div>
</template>

<script setup lang="ts">
/**
 * 尺寸链命令属性面板（尺寸链/水平尺寸链/竖直尺寸链共用）。
 *
 * 面板本体不放置任何内容——只承载 PropertyManager 壳渲染的 ✓/✗ 按钮
 * （确认并结束命令，与 Esc 同语义）；选点/放置全部在视口内完成。
 */
import type { PropertyManagerContext } from '@/core';

defineProps<{
  context: PropertyManagerContext;
}>();
</script>
